function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M45 9.7c-3.8-2-8.2-3.2-12.8-3.2-10.3 0-19.3 5.8-23.9 14.3C6.2 24.6 5 29 5 33.7c0 15 12.2 27.2 27.3 27.2 15 0 27.2-12.2 27.2-27.2 0-5.3-1.5-10.2-4.1-14.4L32.9 48.9c-.5.6-1.2 1-1.9 1h-.1c-.2 0-.4 0-.5-.1-.5-.1-1-.4-1.4-.8L15.2 33c-.3-.4-.5-.9-.6-1.3-.1-.8.2-1.6.9-2.2.5-.4 1.2-.6 1.8-.6.2 0 .4.1.6.1.2.1.3.1.4.2.2.1.4.3.6.5l11.7 13.7",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3 5.2zM66.6.5c-1.1-.8-2.6-.6-3.5.5l-7.8 10.2-3.1 4-21.4 28.2L19 29.7c-.2-.2-.4-.4-.6-.5-.1-.1-.3-.2-.4-.2-.2-.1-.4-.1-.6-.1-.6 0-1.3.1-1.8.6-.7.6-.9 1.4-.9 2.2.1.5.3.9.6 1.3L29 49c.4.4.8.7 1.4.8.2 0 .4.1.5.1h.1c.8 0 1.5-.4 1.9-1l22.5-29.5c2.6 4.2 4.1 9.1 4.1 14.4 0 15-12.2 27.2-27.2 27.2C17.2 60.9 5 48.8 5 33.7c0-4.7 1.2-9.1 3.3-13 4.6-8.5 13.6-14.2 23.9-14.3 4.6 0 9 1.2 12.8 3.2l-2.4-1.2c-1.3-.5-2-1.9-1.4-3.1.6-1.3 2.1-1.9 3.3-1.3l2.7 1.2c-4.5-2.4-9.6-3.7-15-3.7C14.4 1.5 0 15.9 0 33.7 0 51.5 14.4 66 32.3 66c17.8 0 32.2-14.4 32.2-32.3 0-6.9-2.2-13.3-5.9-18.6L67.1 4c.8-1.1.6-2.6-.5-3.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.2 5.3c-.6 1.3.1 2.7 1.4 3.1L45 9.7l.1.1c1.2.6 2.8 0 3.4-1.2.5-1.2 0-2.7-1.2-3.3 0 0-.1 0-.1-.1L44.5 4c-1.2-.6-2.7 0-3.3 1.3z"
});

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67.6 66"
  }, props), _ref, _ref2, _ref3);
};

export default SvgCheckmark;